import React from 'react';
import { PieChart, Pie, Legend, Cell, Tooltip, ResponsiveContainer } from 'recharts';

import { screenWidth } from '../../Constants';
import DownloadChartButton from '../Buttons/DownloadChartButton';
import { theme } from '../../tailwind.config';
import CustomizedLabel from './CustomizedLabel';
import { renderLegend } from '../../helpers/renderLegend';
import useInputContext from '../../hooks/useInputContext';
import { useChartData } from '../../hooks/useChartData';
import Loading from '../general/Loading';
import { CustomTooltipPiechart } from '../../helpers/CustomizedTooltip';

const COLORS = [
  `${theme.colors['yellow']}`,
  `${theme.colors['micro-solar-battery']}`,
  `${theme.colors['micro-solar-grid']}`,
  `${theme.colors['micro-solar-curtailed']}`,
];

/**
 * The RemainingPowerPieChart component
 *
 * @return {JSX.Element}
 */
export default function SolarPowerUsage() {
  const { runId } = useInputContext();
  const { data, isLoading, isError, error } = useChartData(runId, 'solar_power_usage');
  const chartName = 'Solar Power Usage';
  const elements = document.querySelector('#solarpower-chart');

  return (
    <>
      <div className="chart-container">
        <div className="flex items-center justify-between pb-8">
          <h2 className="text-xl uppercase">{chartName}</h2>
          {!isLoading && !!data.length && (
            <DownloadChartButton isLoading={isLoading} name={chartName} elements={elements} />
          )}
        </div>
        {isLoading ? (
          <Loading />
        ) : isError ? (
          <p>{error}</p>
        ) : (
          <ResponsiveContainer height={screenWidth <= theme.screens.md.value ? 300 : 500}>
            <PieChart>
              <Pie
                dataKey="value"
                isAnimationActive={true}
                data={data}
                labelLine={false}
                paddingAngle={0}
                label={<CustomizedLabel fill="black" />}
              >
                {/* maps over the data object and returns the piece of the pie chart in the right color */}
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltipPiechart />} />
              <Legend
                formatter={renderLegend}
                align="center"
                verticalAlign="bottom"
                layout="horizontal"
              />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
    </>
  );
}
